<template>
  <div class="flightticket">
    <b-card class="unbold m-0 mt-3 p-0 border-secondary">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col>
            <b-button
              v-print="'#flightticket'"
              squared
              size="sm"
              class="mr-1"
              title="Print"
              :disabled="busy"
            >
              <i class="fa fa-print pr-3"></i>Print
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button
                class="mr-1"
                squared
                size="sm"
                variant="primary"
                @click="download()"
                disabled
              >
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
      <b-overlay :show="busy" rounded="sm">
        <div v-if="busy" class="h1 text-center text-primary">
          One moment building the ticket
        </div>
        <b-card-body>
          <div class="printheader">
            <div>
              <img src="/img/brand/tp_logo.png" alt="Travel Places" />
            </div>
            <br />
            <br />
          </div>
          <div v-if="loading" class="text-center my-2">
            <b-spinner variant="primary" class="align-middle mr-2"></b-spinner>
            <strong class="text-primary">Loading...</strong>
          </div>
          <div>{{ item }}</div>
          <div id="flightticket" v-if="!loading && item" class="mb-3 ticket">
            <b-row>
              <b-col
                cols="1"
                class="
                  header-primary
                  radius-top-left radius-bottom-left
                  hidden-sm
                "
              ></b-col>
              <b-col cols="8" class="border-right-light-dashed hidden-sm">
                <b-row class="header-primary">
                  <b-col>
                    <div class="logo">
                      <img src="/img/brand/tp_logo.png" alt="Travel Places" />
                      <div class="inline float-right text-white pl-2">
                        TRAVEL PLACES
                      </div>
                    </div>
                  </b-col>
                  <!-- <b-col cols="4" class="text-white uppercase text-right mt-2">
                    <span class>CLASS</span>
                    <div>{{ item.ClassDescription }}</div>
                  </b-col> -->
                </b-row>
                <!-- <b-row class="mt-2">
                  <b-col>
                    <span class="text-muted">PASSENGER</span>
                    <div>{{ item.PaxName }}</div></b-col
                  >
                  <b-col>
                    <span class="text-muted">FLIGHT</span>
                    <div>{{ item.Airline }} {{ item.FlightNo }}</div></b-col
                  >
                </b-row> -->
                <!-- <b-row class="mt-4 mb-2">
                  <b-col>
                    <span class="font-5x pr-1">
                      {{ item.DepartureAirportCode }}
                    </span>
                    <i class="fa fa-3x fa-map-marker text-muted"></i
                  ></b-col>
                  <b-col>
                    <i class="fa fa-3x fa-plane text-muted"></i>
                    <span class="font-5x pl-1">{{
                      item.ArrivalAirportCode
                    }}</span></b-col
                  >
                </b-row> -->
                <!-- <b-row class="mt-2 mb-2">
                  <b-col>
                    <span class="text-muted">CLASS</span>
                    <div class="large">{{ item.Class }}</div></b-col
                  >
                  <b-col>
                    <span class="text-muted">GATE</span>
                    <div class="large">{{ item.SectorNo }}</div></b-col
                  >
                  <b-col>
                    <span class="text-muted">DATE</span>
                    <div>
                      <span class="large pr-2">{{ item.DepartureDate }}</span>
                    </div></b-col
                  >
                  <b-col>
                    <span class="text-muted">TIME</span>
                    <div>
                      <span class="large pr-2">{{ item.DepartureTime }}</span>
                    </div></b-col
                  >
                </b-row> -->
                <!-- <b-row class="mt-3 mb-3">
                  <b-col>
                    <span
                      >ETKT: {{ item.TicketNo }}<br />
                      Locator: {{ item.VendorLocator }}</span
                    ></b-col
                  >
                  <b-col class="text-right mr-3"
                    ><span>BAG: {{ item.Bags }}</span></b-col
                  >
                  <b-col class="text-right">
                    <barcode
                      id="barcode"
                      class="barcode"
                      :value="item.TicketNo"
                      :options="barcode_options"
                      :title="item.TicketNo"
                    ></barcode>
                  </b-col>
                </b-row> -->
              </b-col>
              <b-col
                md-3
                offset-md-0
                sm-6
                offset-sm-6
                class="border-left-light-dashed"
              >
                <b-row class="header-primary radius-top-right">
                  <b-col cols="4">
                    <div class="logo">
                      <img src="/img/brand/tp_logo.png" alt="Travel Places" />
                    </div>
                  </b-col>
                  <!-- <b-col class="text-white uppercase text-right mt-2">
                    <span class>CLASS</span>
                    <div>{{ item.ClassDescription }}</div></b-col
                  > -->
                </b-row>
                <!-- <b-row class="mt-2 mb-2">
                  <b-col>
                    <span class="text-muted">PASSENGER</span>
                    <div>{{ item.PaxName }}</div></b-col
                  >
                </b-row>
                <b-row class="mt-2 mb-2">
                  <b-col> <span class="text-muted">FROM:</span></b-col>
                  <b-col>
                    <span>{{ item.DepartureAirportName }}</span></b-col
                  >
                </b-row>
                <b-row class="mt-2 mb-2"
                  ><b-col> <span class="text-muted">TO:</span></b-col>
                  <b-col>
                    <span>{{ item.ArrivalAirportName }}</span></b-col
                  >
                </b-row>
                <b-row class="mt-2 mb-2">
                  <b-col>
                    <span class="text-muted">FLIGHT</span>
                    <div>{{ item.FlightNo }}</div></b-col
                  >
                  <b-col>
                    <span class="text-muted">CLASS</span>
                    <div>{{ item.Class }}</div></b-col
                  >
                </b-row>
                <b-row class="mt-2 mb-2">
                  <b-col>
                    <span class="text-muted">DATE</span>
                    <div>{{ item.DepartureDate }}</div></b-col
                  >
                  <b-col>
                    <span class="text-muted">TIME</span>
                    <div>{{ item.DepartureTime }}</div></b-col
                  >
                </b-row>
                <b-row class="mt-2 mb-2 pb-1">
                  <b-col>
                    <span class="text-muted">SEAT</span>
                    <div class="large">{{ item.SectorType }}</div></b-col
                  >
                  <b-col>
                    <span class="text-muted">DEPARTURE</span>
                    <div class="large">{{ item.DepartureTime }}</div></b-col
                  >
                </b-row> -->
              </b-col>
            </b-row>
          </div>
          <div v-if="!loading && !item" class="text-muted">
            There are no further details to show
          </div>
        </b-card-body>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import VueBarcode from "@chenfengyuan/vue-barcode";

export default {
  name: "Ticketviewer_Car",
  components: {
    barcode: VueBarcode,
  },
  props: ["selected"],
  data() {
    return {
      busy: false,
      barcode_options: {
        // lineColor: '#ff7069',
        fontSize: 54,
        font: "Courier",
        width: 3,
        height: 100,
        marginBottom: 50,
        background: "#fff",
      },
      loading: false,
      item: null,
      TicketNo: null,
      SectorNo: null,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:selected", newVal);
          this.TicketNo = newVal[0].TicketNo;
          this.SectorNo = newVal[0].SectorNo;
          this.loadData();
        }
      },
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      let variables = {
        slac: this.selected[0].ClientCode,
        pax: this.selected[0].PaxName,
      };
      console.log("variables: ", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query cars($id: String) {
              cars(id: $id) {
                id
                driver
                slac
                blac
                blphone
                car
                cargroup
                confirmationno
                pickupdate
                pickuptime
                pickuplocation
                dropoffdate
                dropofftime
                dropofflocation
                message
                agent
                notes
                supplier {
                  name
                }
                client {
                  name
                  slac
                }
                consultant {
                  initials
                  email
                }
              }
            }
          `,
          variables,
        });
        if (response.data.mobile_cars.result.length > 0) {
          for (var i = 0; i < response.data.mobile_cars.result.length; i++) {
            let ticket = response.data.mobile_cars.result[i];
            if (
              ticket.TicketNo == this.TicketNo &&
              ticket.SectorNo == this.SectorNo
            ) {
              this.item = response.data.mobile_cars.result[i];
              console.log("ticket result", this.item);
              break;
            }
          }
        }
      } catch (error) {}
      this.loading = false;
    },
    discard() {
      this.$emit("discard");
    },
  },
};
</script>

<style>
</style>
